module.exports = __webpack_public_path__ + "img/Industry4G.39936b5f.jpg";